import React from 'react';
import classNames from 'classnames';
import './Chip.styl';
// similar to material ui chip:
// https://v0.material-ui.com/#/components/chip
export default ({children, onRemove, background}) => {
  return (
    <span
      className={classNames('chip list-item', {'has-color': !!background})}
      style={{backgroundColor: background}}
      onClick={onRemove}>
      <span className="text">{children}</span>
      <span className="remove-button"> x</span>
    </span>
  );
};
